export default __webpack_public_path__ + "static/ac690c5a-cc43-4b72-953d-b270d8c2d13d-b3bbd82ed1049565eaf31215879603e0.woff2";